export const customEn = {
  StepsTitle: 'Meet Singles Over 55 Near You'
};
export const customEs = {
  StepsTitle: 'Conoce solteros mayores de 55 años cerca de ti'
};
export const customDa = {
  StepsTitle: 'Mød singler over 55 nær dig'
};
export const customDe = {
  StepsTitle: 'Triff heute Singles über 55 in deiner Nähe'
};
export const customFi = {
  StepsTitle: 'Tapaa yli 55-vuotiaita sinkkuja lähelläsi'
};
export const customSv = {
  StepsTitle: 'Möt singlar över 55 nära dig'
};
export const customFr = {
  StepsTitle: 'Rencontrez des célibataires de plus de 55 ans près de chez vous'
};
export const customHu = {
  StepsTitle: 'Találkozz 55 feletti szinglikkel a közeledben'
};
